<template>
  <div>
    <div class="columns" 
      :class="{'half-height mb-0 overfllow-y-scroll-mobile': selected_item.id && !form_fullscreen}">
      <div class="column is-flex is-flex-direction-column pb-0 overflow-auto" v-if="!form_fullscreen">
        <div class="level p-0 m-0">
          <div class="level-left">
            <grid-col-manage :columnDefs="columnDefs.filter(f => !['action', 'name'].includes(f.field))"
              :hiden_columns="hiden_columns" @toggle_column="toggle_column"></grid-col-manage>
            <div class="level-item">Magazinat</div>
            <input class="input" style="margin: 5px; width: 300px" type="text" placeholder="Kerko..."
              v-model="global_search_filter" @input="onFilterTextBoxChanged">
          </div>
          <div class="level-right">
            <div class="level">
              <a @click.prevent="openModal('cities')" class="pr-2 mr-2 border-r ">
                <small>Qytete</small>
              </a>
              <a @click.prevent="openModal('facilities')" class="button is-small mr-2" title="Objektet e magazinës">
                <i class="fa-solid fa-warehouse mr-1"></i>
                Objektet
              </a>
              <a @click.prevent="exportWarehouses" class="pr-2 mr-2 border-r ">
                <small>{{ exporting ? 'Duke shkarkuar...' : 'Eksporto Excel' }}</small>
              </a>
              <a v-if="am_allowed('transactions.can_create_warehouses')" @click.prevent="create_warehouse">
                <i class="fa fa-plus"></i>
              </a>
            </div>
          </div>
        </div>
        <ag-grid-vue 
          style="width: 100%; min-height: 40vh; height:80vh;" 
          class="ag-theme-balham is-flex-grow-1"
          :columnDefs="columnDefs" :rowData="rowData.value" :rowSelection="rowSelection" :context="context"
          :localeText="localeText" :animateRows="true" @grid-ready="onGridReady">
        </ag-grid-vue>
      </div>
      <div class="column warehouse-form-column overflow-auto" :class="form_fullscreen ? 'is-12' : 'is-5'" v-if="form_edit || form_create">
        <DaForm v-if="form_create" @submitted="submitWarehouse" :closes_form="true" @close="closeWarehouseForm"
          :form="form_create" :fullscreen="form_fullscreen" @toggle-fullscreen="toggleFormFullscreen"></DaForm>
        <template v-if="form_edit">
          <div class="tabs is-boxed is-size-7 warehouse-form-tabs mb-0">
            <ul>
              <li :class="{ 'is-active': warehouseFormTab === 'form' }">
                <a @click.prevent="warehouseFormTab = 'form'">Magazina</a>
              </li>
              <li :class="{ 'is-active': warehouseFormTab === 'history' }">
                <a @click.prevent="warehouseFormTab = 'history'">Historik</a>
              </li>
            </ul>
          </div>
          <DaForm
            v-show="warehouseFormTab === 'form'"
            @submitted="submitWarehouse"
            :closes_form="true"
            @close="closeWarehouseForm"
            :form="form_edit"
            :fullscreen="form_fullscreen"
            @toggle-fullscreen="toggleFormFullscreen"
          ></DaForm>
          <div v-if="warehouseFormTab === 'history'" class="warehouse-form-history px-2 pb-3">
            <div class="warehouse-form-history-title">Logu audit i magazinave</div>
            <warehouse-audit :warehouse-guid="formEditGuid" :reload-key="historyReloadKey" :compact="true"></warehouse-audit>
          </div>
        </template>
      </div>
    </div>
    <div v-if="selected_item.id && !form_fullscreen" class="mt-2">
      <div class="is-flex">
        <a @click.prevent="close_selected_item()" href="" class="delete is-small ml-auto mb-1 mr-2"></a>
      </div>
      <div class="columns border-t-2 border-slate-200 mt-3 overflow-auto">
        <div class="column is-4">
          <warehouse-details :selected_item="selected_item"></warehouse-details>
        </div>
        <div class="column is-8">
          <div class="">
            <div class="tabs is-fullwidth is-boxed is-size-7">
              <ul>
                <li :class="{'is-active': show_tab == 1}"><a @click.prevent="show_tab = 1">Historik</a></li>
                <li :class="{'is-active': show_tab == 2}"><a @click.prevent="show_tab = 2">Shitje</a></li>
                <li :class="{'is-active': show_tab == 3}"><a @click.prevent="show_tab = 3">Blerje</a></li>
                <li :class="{'is-active': show_tab == 4}"><a @click.prevent="show_tab = 4">Porosi</a></li>
                <li :class="{'is-active': show_tab == 5}"><a @click.prevent="show_tab = 5">Rezervime</a></li>
                <li :class="{'is-active': show_tab == 6}"><a @click.prevent="show_tab = 6">Garanci</a></li>
              </ul>
            </div>
          </div>
          <div class="px-2" style="border:solid 1px #dbdbdb; border-width:0px 1px 1px 1px;">
            <div v-if="show_tab == 1" class="py-2">
              <warehouse-audit :warehouse-guid="selected_item.guid" :reload-key="historyReloadKey"></warehouse-audit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { AgGridVue } from "ag-grid-vue3";
import DaForm from "@/components/daform/index.vue";
import ButtonsCell from "@/components/buttonscell/ButtonsCell.vue";
import createWarehouse from "./forms/warehouses/create";
import editWarehouse from "./forms/warehouses/edit";
import locale from "@/components/ag-grid/locale/al/al.js"
import WarehousesServices from "@/services/Warehouse";
import permissionMixin from '@/mixins/permissions-mixin.js'
import { $vfm } from 'vue-final-modal'
import socket from "@/socket.js";
import { defineAsyncComponent, onUnmounted, reactive, inject } from "vue"
import gridColManage from "@/components/grid_col_manage.vue";
import warehouseDetails from "./components/warehouse-details";
import warehouseAudit from "./components/warehouse-audit";
export default {
  mixins: [permissionMixin],
  components: {
    AgGridVue,
    DaForm,
    gridColManage,
    warehouseDetails,
    warehouseAudit
  },
  setup() {
    let rowData = reactive([])
    const toast = inject('toast')
    socket.connect()
    socket.on("welcome", data => {
      console.log("welcome", data)
    })
    socket.on("propagate", data => {
      if (data.action == "create") {
        var a = rowData.value
        a.push(data.data)
        rowData.value = [...a]
        toast.success(
          "Magazina u krijua <i>nga " + data.created_by.name + "</i>"
        );
      }
      if (data.action == "edit") {
        rowData.value = [...rowData.value.map(e => {
          if (e.id == data.data.id) {
            return data.data
          }
          return e
        })]
        toast.success(
          "Magazina u modifikua <i>nga " + data.created_by.name + "</i>"
        );
      }
    })
    onUnmounted(() => {
      socket.off("welcome");
      socket.off("propagate");
      socket.disconnect();
    })
    return {
      rowData
    }
  },
  beforeMount() {
    this.context = { componentParent: this };
  },
  data() {
    return {
      global_search_filter: "",
      context: null,
      selectedWarehouse: {},
      open_citiuser_namees: false,
      form_create: null,
      form_edit: null,
      gridApi: null,
      defaultColDef: {
        flex: 1,
        minWidth: 100
      },
      rowSelection: "single",
      localeText: null,
      hiden_columns: ['type_id_name', 'code', 'role', 'location', 'description', 'city_name', 'reservation_warehouse_name', 'priority_order', 'user_name'],
      selected_item: {},
      show_tab: 1,
      transit_warehouses: [],
      exporting: false,
      form_fullscreen: false,
      warehouseFormTab: "form",
      historyReloadKey: 0,
    }
  },
  computed: {
    columnDefs() {
      var a = [
        { headerName: "Emri", width: '300px', field: "name", filter: true, floatingFilter: true, sortable: true, resizable: true, pinned: 'left', show_in_form: true, hide: this.hiden_columns.includes("name") },
        {
          headerName: "Kategoria", field: "type_id_name", filter: true,
          cellRenderer: function (params) {
            let r = ""
            if (params.data.type_id == "EMPTY-STRING" || params.data.type_id == 'undefined')
              r = `<i class="type_id">[SKA KATEGORI]</i>`
            else
              r = params.data.type_id_name
            return r
          },
          floatingFilter: true, sortable: true, show_in_form: true, hide: this.hiden_columns.includes("type_id_name")
        },
        { headerName: "Kodi", field: "code", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("code") },
        { headerName: "Adresa", field: "location", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("location") },
        { headerName: "Qyteti", field: "city_name", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("city_name") },
        { headerName: "Pershkrimi", field: "description", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("description") },
        {
          headerName: "Roli", field: "role", filter: true, hide: this.hiden_columns.includes("role"),
          cellRenderer: function (params) {
            let r = ""
            if (params.data.role) {
              r = params.data.role
              if (params.data.role == '1')
                r = "Primar"
              if (params.data.role == '2')
                r = "Sekondar"
            }
            return r
          },
          floatingFilter: true, sortable: true, resizable: true, show_in_form: false
        },
        { headerName: "Personi pergjegjes", field: "user_name", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: false, hide: this.hiden_columns.includes("user_name") },
        { headerName: "Njesia e biznesit", field: "unit_name", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("unit_name") },
        {
          headerName: "Magazina e rezervimit", field: "reservation_warehouse_name", hide: this.hiden_columns.includes("reservation_warehouse_name"),
          cellRenderer: function (params) {
            let r = ''
            if (params.data.warehouse_facility == '1') {
              if (!params.data.reservation_warehouse_name)
                r = `<i class="reservation_warehouse"> [E PAPERCAKTUAR] </i>`
              else
                r = params.data.reservation_warehouse_name
            }
            return r
          },
          filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true
        },
        { headerName: "Objekti i magazines", field: "facility_name", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("facility_name") },
        {
          headerName: "Lloji", field: "kind", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("kind"),
          cellRenderer: function (params) {
            if (params.data.kind == 'prod') return 'Prod'
            if (params.data.kind == 'aset') return 'Aset'
            return params.data.kind || ''
          }
        },
        { headerName: "Tipi", field: "warehouse_type", filter: true, floatingFilter: true, sortable: true, resizable: true, show_in_form: true, hide: this.hiden_columns.includes("warehouse_type") },
        {
          headerName: "Në web", field: "in_web", filter: true, hide: this.hiden_columns.includes("in_web"),
          cellRenderer: function (params) {
            if (params.data.in_web == '1' || params.data.in_web === 1)
              return `<i class="fa-regular fa-circle-check fa-lg"></i>`
            return `<i class="fa-regular fa-circle-xmark fa-lg"></i>`
          },
          floatingFilter: true, sortable: true, resizable: true, show_in_form: true
        },
        {
          headerName: "Aktiv", field: "active", filter: true, hide: this.hiden_columns.includes("active"),
          cellRenderer: function (params) {
            let r = ""
            if (params.data.active == '0')
              r = `<i class="fa-regular fa-circle-xmark fa-lg"></i>`
            else if (params.data.active == '1')
              r = `<i class="fa-regular fa-circle-check fa-lg"></i>`
            return r
          },
          floatingFilter: true, sortable: true, resizable: true, show_in_form: false
        },
        {
          headerName: "Rendi i prioritetit", field: "priority_order", filter: true, hide: this.hiden_columns.includes("priority_order"),
          cellRenderer: function (params) {
            let r = ""
            if (params.data.priority_order == '1')
              r = "Rendi kryesor"
            else if (params.data.priority_order == '2')
              r = "Rendi 2"
            else if (params.data.priority_order == '3')
              r = "Rendi 3"
            return r
          },
          floatingFilter: true, sortable: true, resizable: true, show_in_form: false
        },
        {
          headerName: "Action",
          cellRenderer: ButtonsCell,
          cellRendererParams: this.context,
          resizable: true,
          show_in_form: true,
          pinned: 'right',
          field: "action",
          hide: this.hiden_columns.includes("action"),
        }
      ]
      if (this.form_create || this.form_edit) {
        return [...a.filter(e => e.show_in_form)]
      }
      return [...a]
    },
    formEditGuid() {
      return this.selectedWarehouse?.guid || this.form_edit?.guid || this.selected_item?.guid || "";
    },
  },

  methods: {
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(this.global_search_filter)
    },
    open_cities_form() {
      this.open_cities = !this.open_cities
    },
    async open(mode, warehouse) {
      if (mode == "1") {
        if (this.am_allowed('transactions.can_edit_warehouses')) {
          this.form_create = null
          this.form_fullscreen = false
          if (warehouse) {
            this.selectedWarehouse = warehouse
            this.form_edit = null
            this.form_edit = { loading: true }
            this.warehouseFormTab = "form"
            this.form_edit = await editWarehouse(warehouse)
          }
        } else {
          this.$toast.error('Nuk keni te drejta te modifikoni magazine.')
        }
      }
      if(mode == '0') {
        const guid = warehouse?.guid || warehouse
        const details = await WarehousesServices.getWarehouseData(guid)
        this.selected_item = { ...warehouse, ...(details || {}) }
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit();
      this.gridColumnApi = params.columnApi
    },
    async create_warehouse() {
      this.form_edit = null
      this.form_fullscreen = false
      this.form_create = { loading: true }
      this.form_create = await createWarehouse()
    },
    closeWarehouseForm() {
      this.form_create = null
      this.form_edit = null
      this.form_fullscreen = false
      this.warehouseFormTab = "form"
      setTimeout(() => {
        if (this.gridApi) this.gridApi.sizeColumnsToFit()
      }, 100)
    },
    toggleFormFullscreen() {
      this.form_fullscreen = !this.form_fullscreen
      setTimeout(() => {
        if (this.gridApi) this.gridApi.sizeColumnsToFit()
      }, 100)
    },
    async submitWarehouse(w) {
      if (this.form_create != null) {
        var notify_text = ""
        let warehouse = await WarehousesServices.createWarehouse(w)
        var a = this.rowData.value
        a.push(warehouse)
        this.rowData.value = [...a]
        socket.emit("propagate", { action: "create", data: warehouse })
        notify_text = "Magazina u krijua me sukses!"
        this.form_create = null
        this.form_fullscreen = false
        this.$root.selected_one = {}
      }
      else {
        w.guid = this.selectedWarehouse.guid
        let warehouse = await WarehousesServices.editWarehouse(w)
        this.rowData.value = [...this.rowData.value.map(wa => {
          if (wa.guid == warehouse.guid) wa = { ...warehouse }
          return wa
        })]
        socket.emit("propagate", { action: "edit", data: warehouse })
        notify_text = "Magazina u modifikua me sukses!"
        this.historyReloadKey += 1
        this.form_edit = null
        this.form_fullscreen = false
        this.$root.selected_one = {}
      }
      setTimeout(() => {
        if (this.gridApi) this.gridApi.sizeColumnsToFit();
      }, 100);
      this.$toast.success(notify_text)
    },
    openModal(modalName) {
      $vfm.show({
        component: defineAsyncComponent(
          () => import("./components/" + modalName + "-modal.vue")
        ),
      })
    },
    toggle_column(column) {
      if (this.hiden_columns.includes(column)) {
        this.hiden_columns = [...this.hiden_columns.filter(item => item != column)]
      } else {
        this.hiden_columns.push(column)
      }

      setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 100);
    },
    async exportWarehouses() {
      if (this.exporting) return
      this.exporting = true
      try {
        const response = await WarehousesServices.exportWarehouses()
        WarehousesServices.saveBlobDownload(response, "magazinat.xls")
        this.$toast.success("Lista e magazinave u shkarkua.")
      } catch (error) {
        this.$toast.error(error?.response?.data?.message || "Eksporti dështoi.")
      } finally {
        this.exporting = false
      }
    },
    close_selected_item() {
      this.selected_item = { ...{} }
    },
  },

  async created() {
    if (!this.am_allowed('transactions.can_see_warehouses')) {
      window.location.href = '/home'
    }
    this.localeText = locale.locale_al()
    this.rowData.value = await WarehousesServices.getWarehouses()
    // this.transit_warehouses = await WarehousesServices.getTransitWarehouses()

    // this.rowData.value.map(w => {
    //   if(!w.transit_warehouses) w.transit_warehouses = []
    //   this.transit_warehouses.map(gw => {
    //     if(w.guid == gw.warehouse){
    //       w.transit_warehouses.push(gw)
    //       console.log(w)
    //     }
    //   })
    //   return w
    // })


    this.gridApi.sizeColumnsToFit();
  },
  onBeforeDestroy() {
    socket.disconnect();
  },
}
</script>

<style>
.reservation_warehouse, .type_id {
  color: rgb(235, 8, 8);
}
.half-height {
  height: 40vh;
}
.warehouse-form-column {
  max-height: calc(100vh - 90px);
}
.warehouse-form-column.is-12 {
  max-height: none;
  min-height: calc(100vh - 90px);
  background: #f8fafc;
  margin: -8px -12px 0;
  padding: 8px 12px 24px;
}
.warehouse-form-tabs {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  padding-top: 0.35rem;
}
.warehouse-form-tabs ul {
  margin-bottom: 0;
  border-bottom-color: #dbdbdb;
}
.warehouse-form-history {
  border: solid 1px #dbdbdb;
  border-top: 0;
  min-height: 12rem;
  background: #fff;
}
.warehouse-form-history-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  padding-top: 10px;
}
</style>
